import { memo, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { UPLOAD_DOCUMENT_WRAPPER } from 'utils/constants.json';

const UploadToggler = ({ setUploadDocumentOpen }) => {
	const [container, setContainer] = useState(() => null);

	useEffect(() => setContainer(document.getElementById(UPLOAD_DOCUMENT_WRAPPER)), []);

	if (!container) return null;

	return createPortal(<i title='Dokument hochladen' className='fa fa-upload upload-file ml-3 pointer' onClick={() => setUploadDocumentOpen(true)} />, container);
};

export default memo(UploadToggler);
